export function initKbFix() {
  if (!document.querySelector('.kb-plugin-wrap')) return;

  const fix = () => {
    // Fix category card widths (plugin CSS beats our !important rules)
    document.querySelectorAll('.epkb-top-category-box').forEach(el => {
      el.style.setProperty('width', '100%', 'important');
    });

    // Fix search box background
    const searchBox = document.getElementById('epkb-ml-search-box');
    if (searchBox) {
      searchBox.style.setProperty('background-color', 'rgba(255,255,255,0.07)', 'important');
      searchBox.style.setProperty('border', '1px solid rgba(255,255,255,0.15)', 'important');
    }

    // Fix search input text color
    const searchInput = document.querySelector('#epkb-ml-search-box .epkb-ml-search-box__input');
    if (searchInput) {
      searchInput.style.setProperty('color', '#ffffff', 'important');
      searchInput.style.setProperty('background', 'transparent', 'important');
    }

    // Fix search button background to site primary red
    const searchBtn = document.querySelector('#epkb-ml-search-box .epkb-ml-search-box__btn');
    if (searchBtn) {
      searchBtn.style.setProperty('background-color', '#dc1b1e', 'important');
      searchBtn.style.setProperty('color', '#ffffff', 'important');
    }
  };

  fix();

  // Re-run after a short delay in case EPKB JS overwrites styles after DOMContentLoaded
  setTimeout(fix, 300);
}
